import { AxDatePicker, Cell } from "./AxDatepicker";
import { Direction } from "./EventHelper";

export class InteractionHelper {
    constructor() { }

    private Class_range: string = 'in-range';
    private Class_e_month: string = 'in-range--e-month';
    private Class_a_month: string = 'in-range--a-month';
    private Class_e_week: string = 'in-range--e-week';
    private Class_a_week: string = 'in-range--a-week';
    private Class_range_end: string = 'in-range--end';

    private Class_active: string = 'active';

    private TextCache: TextCacheEntry[] = [];

    ActivateDay(cell: Cell, parent: AxDatePicker, informSubscribers: boolean) {
        if (!cell.Element.classList.contains('axp__cell-blocked')) {
            this.unsetDate(parent, false);

            cell.Element.classList.add(this.Class_active);
            cell.Active = true;
            
            if (cell.DayRange > 0) {
                this.SetActiveRange(cell, parent);
            }

            if (informSubscribers) {
                parent.ActivationSubject.next(cell);
            }
        }
    }

    unsetDate(parent: AxDatePicker, sendSubscription: boolean) {
        for (let tmpCell of parent.Cells.filter(x => x.Active)) {
            tmpCell.Active = false;
            tmpCell.Element.classList.remove(this.Class_active);
        }
        this.DeactivateDayRange(parent);

        if (sendSubscription) {
            parent.ActivationSubject.next(null);
        }
    }

    SetActiveRange(cell: Cell, parent: AxDatePicker) {
        let targetDate = moment(cell.Date).add(cell.DayRange, 'd');

        let filteredCells = parent.Cells.filter(x => x.Date.isAfter(cell.Date) && x.Date.isBefore(targetDate));

        if (filteredCells.length >= 1) {
            if (cell.Date.isSame(moment(cell.Date).endOf('month'), 'day')) {
                cell.Element.classList.add(this.Class_e_month);
            }

            if (cell.Date.isSame(moment(cell.Date).endOf('week'), 'day')) {
                cell.Element.classList.add(this.Class_e_week);
            }

            for (let tmpCell of filteredCells) {
                let tmpDate = moment(tmpCell.Date);
                if (tmpDate.isSame(moment(tmpCell.Date).endOf('month'), 'day')) {
                    tmpCell.Element.classList.add(this.Class_e_month);
                }

                if (tmpDate.isSame(moment(tmpCell.Date).startOf('month'), 'day')) {
                    tmpCell.Element.classList.add(this.Class_a_month);
                }

                if (tmpDate.isSame(moment(tmpCell.Date).endOf('week'), 'day')) {
                    tmpCell.Element.classList.add(this.Class_e_week);
                }

                if (tmpDate.isSame(moment(tmpCell.Date).startOf('week'), 'day')) {
                    tmpCell.Element.classList.add(this.Class_a_week);
                }

                if (tmpDate.isSame(moment(targetDate).add(-1, 'day'), 'day')) {
                    tmpCell.Element.classList.add(this.Class_range_end);
                }

                tmpCell.Element.classList.add(this.Class_range);
                tmpCell.InRange = true;
            }
        }
    }

    DeactivateDay(cell: Cell, parent: AxDatePicker) {
        cell.Active = false;
        cell.Element.classList.remove(this.Class_active);
        this.DeactivateDayRange(parent);
        parent.ActivationSubject.next(null);
    }

    DeactivateDayRange(parent: AxDatePicker) {
        for (let tmpCell of parent.Cells.filter(x => x.InRange || x.Active)) {
            tmpCell.Element.classList.remove(this.Class_range);
            tmpCell.Element.classList.remove(this.Class_e_month);
            tmpCell.Element.classList.remove(this.Class_a_month);
            tmpCell.Element.classList.remove(this.Class_e_week);
            tmpCell.Element.classList.remove(this.Class_a_week);
            tmpCell.Element.classList.remove(this.Class_range_end);
            tmpCell.InRange = false;
        }
    }

    BlockDate(date: moment.Moment, parent: AxDatePicker) {
        let cell = this.findCell(date, parent);

        if (cell != null || cell != undefined) {
            cell.Element.classList.add('axp__cell-blocked');

            if (cell.Active) {
                this.DeactivateDay(cell, parent);
            }
        }
    }

    findCell(date: moment.Moment, parent: AxDatePicker) {
        return parent.Cells.find(x => x.Date.isSame(date, 'day'));
    }

    UnblockDate(date: moment.Moment, parent: AxDatePicker) {
        this.findCell(date, parent)?.Element.classList.remove('axp__cell-blocked');
    }

    AddText(date: moment.Moment, text: string, parent: AxDatePicker) {
        this.CacheText(date, text);
        let cell = this.findCell(date, parent);

        if (cell != null || cell != undefined) {
            cell.Text = text;
            cell.Element.classList.toggle('axp__cell--text', cell.Text != '');
            parent.RenderH.AddText(cell);
        }
    }

    FillEmptyText(parent: AxDatePicker) {
        let text = '-';
        for (let cell of parent.Cells.filter(x => x.Text == '')) {
            this.CacheText(cell.Date, text);

            if (cell != null) {
                cell.Text = text;
                cell.Element.classList.toggle('axp__cell--text', cell.Text != '');
                parent.RenderH.AddText(cell);
            }
        }
    }

    RemoveText(date: moment.Moment, parent: AxDatePicker, removeCache: boolean) {
        let cell = this.findCell(date, parent);

        if (cell != null) {
            cell.Text = '';
            cell.Element.classList.toggle('axp__cell--text', cell.Text != '');
            parent.RenderH.RemoveText(cell);

            if (removeCache) {
                this.TextCache = this.TextCache.filter(x => !x.Date.isSame(date, 'day'));
            }
        }
    }

    RemoveAllText(parent: AxDatePicker, removeCache: boolean) {
        if (parent.Cells != null) {
            for (let cell of parent.Cells) {
                cell.Text = '';
                cell.Element.classList.toggle('axp__cell--text', cell.Text != '');
                parent.RenderH.RemoveText(cell);
            }
        }

        if (removeCache) {
            this.TextCache = [];
        }
    }

    LoadCachedText(date: moment.Moment, parent: AxDatePicker) {
        let existingEntry = this.TextCache.find(x => x.Date.isSame(date, 'day'));
        if (existingEntry != null) {
            this.AddText(existingEntry.Date, existingEntry.Text, parent);
        }
    }

    setDate(date: moment.Moment, parent: AxDatePicker, retVal: (x: HTMLElement[], d: Direction) => void) {
        parent.CurrentDate = date;
        parent.RenderH.RenderCalendar().then(x => {
            retVal(x, Direction.Jump);
        });
    }

    Next(parent: AxDatePicker, retVal: (x: HTMLElement[], d: Direction) => void) {
        parent.CurrentDate.add(parent.monthsShown, 'M');
        parent.RenderH.RenderCalendar().then(x => {
            retVal(x, Direction.Forward);
            if (x.length == 0) {
                parent.CurrentDate.add(parent.monthsShown * -1, 'M');
            }
        });
    }

    Previous(parent: AxDatePicker, retVal: (x: HTMLElement[], d: Direction) => void) {
        //if (parent.CurrentStartDate.startOf('month').isSame(parent.Options.StartDate.startOf('month'))) {
        //    return;
        //}

        parent.CurrentDate.add(parent.monthsShown * -1, 'M');
        parent.RenderH.RenderCalendar().then(x => {
            retVal(x, Direction.Backward);
            if (x.length == 0) {
                parent.CurrentDate.add(parent.monthsShown, 'M');
            }
        });
    }


    private CacheText(date: moment.Moment, text: string) {
        let existingEntry = this.TextCache.find(x => x.Date.isSame(date, 'day'));

        if (existingEntry == null) {
            this.TextCache.push({
                Date: date,
                Text: text
            });
        } else {
            existingEntry.Text = text;
        }
    }
}

interface TextCacheEntry {
    Date: moment.Moment;
    Text: string;
}